exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".TopicsTopEntrance[data-v-9cd22194]{display:flex;flex-direction:column}.TopicsTopEntrance-header[data-v-9cd22194]{display:flex;align-items:center;justify-content:space-between;background-color:#eee;font-size:16px;padding:0 10px 0 30px;margin:20px 0}.TopicsTopEntrance-main[data-v-9cd22194]{padding:0 10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-9cd22194&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/yunying/BulletinManagement/PublicBulletinManagement/Detail/index.vue
// module id = 610
// module chunks = 0